import { INDUSTRIES } from "../lib/industries";

export function IndustryBelt() {
  const items = [...INDUSTRIES, ...INDUSTRIES];

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        background: "var(--neutral-950)",
        padding: "var(--space-3) 0",
        borderTop: "1px solid rgba(59,130,246,0.15)",
        borderBottom: "1px solid rgba(59,130,246,0.15)",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "0",
          width: "max-content",
          animation: "belt-scroll 240s linear infinite",
        }}
      >
        {items.map((industry, idx) => (
          <div
            key={`${industry.slug}-${idx}`}
            style={{
              width: "216px",
              height: "96px",
              flexShrink: 0,
              position: "relative",
              overflow: "hidden",
              borderRadius: "6px",
              marginRight: "12px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `url(${industry.backgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(180deg, rgba(10,22,40,0.3) 0%, rgba(10,22,40,0.85) 100%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 12px",
              }}
            >
              <span
                style={{
                  color: "#fff",
                  fontSize: "18px",
                  fontWeight: 700,
                  textAlign: "center",
                  lineHeight: "1.2",
                  textShadow: "0 2px 8px rgba(0,0,0,0.9)",
                }}
              >
                {industry.name}
              </span>
            </div>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes belt-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
